export default __webpack_public_path__ + "static/media/groundplan_84e.bab04954.png";